// Health plugin migrated to @capgo/capacitor-health - no longer need SampleNames import
import { Capacitor } from "@capacitor/core";

export const APP_VERSION = "1.7.0";

/** True when running in a browser rather than a native iOS/Android shell. */
export const IS_WEB_BUILD = Capacitor.getPlatform() === "web";
export const SHOW_THERAPY_CONTROLS = !IS_WEB_BUILD;

/** Kill switch: false disables the remote on web. Native unaffected. */
export const WEB_REMOTE_ENABLED = true;

/** Min height (px) for the web remote graph. */
export const WEB_REMOTE_GRAPH_MIN_HEIGHT = { short: 200, normal: 260 };

export const DECRYPTION_TOOL_URLS: Record<string, string> = {
  production: "https://arcconnect.abmrc.com/decrypt",
  staging: "https://staging-arcconnect.abmrc.com/decrypt",
};
export const WEB_VERSION = "1.5.0";
export const IOS_CATALOG_NUMBER = "AC011";
export const ANDROID_CATALOG_NUMBER = "AC009";
export const IOS_CATALOG_NUMBER_BT = "AC011-01";
export const ANDROID_CATALOG_NUMBER_BT = "AC009-01";
export const BT_VERSION = "1.2.0";
export const countryCodes = [
  // --- Americas (+1: US, CA, Caribbean) ---
  {
    code: "+1",
    country: "Canada (Eastern - Toronto)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Toronto",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Atlantic - Halifax)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Halifax",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Central - Winnipeg)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Winnipeg",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Mountain - Edmonton)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Edmonton",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Pacific - Vancouver)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Vancouver",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Newfoundland - St. John's)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Johns",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Yukon - Whitehorse)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Whitehorse",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Dawson Creek)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Dawson_Creek",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Swift Current)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Swift_Current",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Rankin Inlet)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Rankin_Inlet",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Resolute)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Resolute",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Inuvik)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Inuvik",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Pangnirtung)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Pangnirtung",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Iqaluit)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Iqaluit",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "Canada (Goose Bay)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Goose_Bay",
    maxLength: 10,
  },

  {
    code: "+1",
    country: "United States (Eastern - New York)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/New_York",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Central - Chicago)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Chicago",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Mountain - Denver)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Denver",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Pacific - Los Angeles)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Los_Angeles",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Alaska - Anchorage)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Anchorage",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Hawaii - Honolulu)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Honolulu",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Arizona - Phoenix)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Phoenix",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Indiana - Indianapolis)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Indiana/Indianapolis",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Indiana - Vincennes)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Indiana/Vincennes",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Indiana - Winamac)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Indiana/Winamac",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Indiana - Marengo)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Indiana/Marengo",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Indiana - Petersburg)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Indiana/Petersburg",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Indiana - Tell City)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Indiana/Tell_City",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Kentucky - Louisville)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Kentucky/Louisville",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Kentucky - Monticello)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Kentucky/Monticello",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (North Dakota - Beulah)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/North_Dakota/Beulah",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (North Dakota - Center)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/North_Dakota/Center",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (North Dakota - New Salem)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/North_Dakota/New_Salem",
    maxLength: 10,
  },
  {
    code: "+1",
    country: "United States (Adak)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Adak",
    maxLength: 10,
  },

  {
    code: "+1 242",
    country: "Bahamas",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Nassau",
    maxLength: 10,
  },
  {
    code: "+1 246",
    country: "Barbados",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Barbados",
    maxLength: 10,
  },
  {
    code: "+1 268",
    country: "Antigua and Barbuda",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Antigua",
    maxLength: 10,
  },
  {
    code: "+1 284",
    country: "Virgin Islands, British",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Tortola",
    maxLength: 10,
  },
  {
    code: "+1 340",
    country: "Virgin Islands, U.S.",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/St_Thomas",
    maxLength: 10,
  },
  {
    code: "+1 345",
    country: "Cayman Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Cayman",
    maxLength: 10,
  },
  {
    code: "+1 441",
    country: "Bermuda",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Bermuda",
    maxLength: 10,
  },
  {
    code: "+1 473",
    country: "Grenada",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Grenada",
    maxLength: 10,
  },
  {
    code: "+1 649",
    country: "Turks and Caicos Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Grand_Turk",
    maxLength: 10,
  },
  {
    code: "+1 664",
    country: "Montserrat",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Montserrat",
    maxLength: 10,
  },
  {
    code: "+1 670",
    country: "Northern Mariana Islands",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Saipan",
    maxLength: 10,
  },
  {
    code: "+1 671",
    country: "Guam",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Guam",
    maxLength: 10,
  },
  {
    code: "+1 684",
    country: "American Samoa",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Pago_Pago",
    maxLength: 10,
  },
  {
    code: "+1 758",
    country: "Saint Lucia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Lucia",
    maxLength: 10,
  },
  {
    code: "+1 767",
    country: "Dominica",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Dominica",
    maxLength: 10,
  },
  {
    code: "+1 784",
    country: "Saint Vincent and the Grenadines",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Vincent",
    maxLength: 10,
  },
  {
    code: "+1 849",
    country: "Dominican Republic",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Santo_Domingo",
    maxLength: 10,
  },
  {
    code: "+1 868",
    country: "Trinidad and Tobago",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Port_of_Spain",
    maxLength: 10,
  },
  {
    code: "+1 869",
    country: "Saint Kitts and Nevis",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Kitts",
    maxLength: 10,
  },
  {
    code: "+1 876",
    country: "Jamaica",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Jamaica",
    maxLength: 10,
  },
  {
    code: "+1 939",
    country: "Puerto Rico",
    dateFormat: "MM/DD/YYYY",
    timeZone: "America/Puerto_Rico",
    maxLength: 10,
  },

  // --- Russia and Kazakhstan (+7) ---
  {
    code: "+7",
    country: "Russia (Kaliningrad)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Kaliningrad",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Moscow)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Moscow",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Samara)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Samara",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Yekaterinburg)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Yekaterinburg",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Omsk)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Omsk",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Krasnoyarsk)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Krasnoyarsk",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Irkutsk)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Irkutsk",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Yakutsk)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Yakutsk",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Magadan)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Magadan",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Sakhalin)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Sakhalin",
    maxLength: 10,
  },
  {
    code: "+7",
    country: "Russia (Kamchatka)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Kamchatka",
    maxLength: 10,
  },
  {
    code: "+7 7",
    country: "Kazakhstan (Almaty)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Almaty",
    maxLength: 10,
  },
  {
    code: "+7 7",
    country: "Kazakhstan (Aqtobe)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Aqtobe",
    maxLength: 10,
  },
  {
    code: "+7 7",
    country: "Kazakhstan (Aqtau)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Aqtau",
    maxLength: 10,
  },
  {
    code: "+7 7",
    country: "Kazakhstan (Atyrau)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Atyrau",
    maxLength: 10,
  },
  {
    code: "+7 7",
    country: "Kazakhstan (Oral)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Oral",
    maxLength: 10,
  },

  // --- Mexico (+52) ---
  {
    code: "+52",
    country: "Mexico (Mexico City)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Mexico_City",
    maxLength: 10,
  },
  {
    code: "+52",
    country: "Mexico (Cancun)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Cancun",
    maxLength: 10,
  },
  {
    code: "+52",
    country: "Mexico (Chihuahua)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Chihuahua",
    maxLength: 10,
  },
  {
    code: "+52",
    country: "Mexico (Hermosillo)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Hermosillo",
    maxLength: 10,
  },
  {
    code: "+52",
    country: "Mexico (Mazatlan)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Mazatlan",
    maxLength: 10,
  },
  {
    code: "+52",
    country: "Mexico (Tijuana)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Tijuana",
    maxLength: 10,
  },

  // --- Australia (+61) ---
  {
    code: "+61",
    country: "Australia (Sydney)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Sydney",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Brisbane)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Brisbane",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Adelaide)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Adelaide",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Perth)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Perth",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Darwin)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Darwin",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Lord Howe)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Lord_Howe",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Hobart)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Hobart",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Australia (Broken Hill)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Australia/Broken_Hill",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Christmas Island",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Christmas",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Cocos (Keeling) Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Cocos",
    maxLength: 9,
  },

  // --- Brazil (+55) ---
  {
    code: "+55",
    country: "Brazil (São Paulo)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Sao_Paulo",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Noronha)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Noronha",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Maceio)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Maceio",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Cuiaba)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Cuiaba",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Porto Velho)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Porto_Velho",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Rio Branco)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Rio_Branco",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Belem)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Belem",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Manaus)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Manaus",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Eirunepe)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Eirunepe",
    maxLength: 11,
  },
  {
    code: "+55",
    country: "Brazil (Santarem)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Santarem",
    maxLength: 11,
  },

  // --- Other Multi-Zone Countries ---
  {
    code: "+54",
    country: "Argentina (Buenos Aires)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Buenos_Aires",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Cordoba)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Cordoba",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Jujuy)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Jujuy",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Salta)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Salta",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Catamarca)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Catamarca",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Mendoza)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Mendoza",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (San Luis)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/San_Luis",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Rio Gallegos)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Rio_Gallegos",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Tucuman)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Tucuman",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina (Ushuaia)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/Ushuaia",
    maxLength: 10,
  },

  {
    code: "+62",
    country: "Indonesia (Jakarta)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Jakarta",
    maxLength: 12,
  },
  {
    code: "+62",
    country: "Indonesia (Makassar)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Makassar",
    maxLength: 12,
  },
  {
    code: "+62",
    country: "Indonesia (Jayapura)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Jayapura",
    maxLength: 12,
  },

  {
    code: "+64",
    country: "New Zealand (Auckland)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Auckland",
    maxLength: 10,
  },
  {
    code: "+64",
    country: "New Zealand (Chatham)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Chatham",
    maxLength: 10,
  },

  {
    code: "+56",
    country: "Chile (Santiago)",
    dateFormat: "DD-MM-YYYY",
    timeZone: "America/Santiago",
    maxLength: 9,
  },
  {
    code: "+56",
    country: "Chile (Easter Island)",
    dateFormat: "DD-MM-YYYY",
    timeZone: "Pacific/Easter",
    maxLength: 9,
  },

  {
    code: "+243",
    country: "Congo, The Democratic Republic of the (Kinshasa)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Kinshasa",
    maxLength: 9,
  },
  {
    code: "+243",
    country: "Congo, The Democratic Republic of the (Lubumbashi)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Lubumbashi",
    maxLength: 9,
  },

  {
    code: "+299",
    country: "Greenland (Nuuk)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Nuuk",
    maxLength: 6,
  },
  {
    code: "+299",
    country: "Greenland (Thule)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Thule",
    maxLength: 6,
  },
  {
    code: "+299",
    country: "Greenland (Scoresbysund)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Scoresbysund",
    maxLength: 6,
  },

  {
    code: "+976",
    country: "Mongolia (Ulaanbaatar)",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Ulaanbaatar",
    maxLength: 8,
  },
  {
    code: "+976",
    country: "Mongolia (Hovd)",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Hovd",
    maxLength: 8,
  },
  {
    code: "+976",
    country: "Mongolia (Choibalsan)",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Choibalsan",
    maxLength: 8,
  },

  {
    code: "+998",
    country: "Uzbekistan (Tashkent)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Tashkent",
    maxLength: 9,
  },
  {
    code: "+998",
    country: "Uzbekistan (Samarkand)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Samarkand",
    maxLength: 9,
  },

  // --- Single Zone Countries (Remainder of the IANA Database) ---
  {
    code: "+93",
    country: "Afghanistan",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Kabul",
    maxLength: 9,
  },
  {
    code: "+355",
    country: "Albania",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Tirane",
    maxLength: 9,
  },
  {
    code: "+213",
    country: "Algeria",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Algiers",
    maxLength: 9,
  },
  {
    code: "+684",
    country: "American Samoa",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Pago_Pago",
    maxLength: 10,
  },
  {
    code: "+376",
    country: "Andorra",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Andorra",
    maxLength: 6,
  },
  {
    code: "+244",
    country: "Angola",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Luanda",
    maxLength: 9,
  },
  {
    code: "+1 268",
    country: "Antigua and Barbuda",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Antigua",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/La_Rioja",
    maxLength: 10,
  },
  {
    code: "+54",
    country: "Argentina",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Argentina/San_Juan",
    maxLength: 10,
  },
  {
    code: "+374",
    country: "Armenia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Yerevan",
    maxLength: 8,
  },
  {
    code: "+297",
    country: "Aruba",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Aruba",
    maxLength: 7,
  },
  {
    code: "+247",
    country: "Ascension Island",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Ascension",
    maxLength: 4,
  },
  {
    code: "+43",
    country: "Austria",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Vienna",
    maxLength: 13,
  },
  {
    code: "+994",
    country: "Azerbaijan",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Baku",
    maxLength: 9,
  },
  {
    code: "+1 242",
    country: "Bahamas",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Nassau",
    maxLength: 10,
  },
  {
    code: "+973",
    country: "Bahrain",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Bahrain",
    maxLength: 8,
  },
  {
    code: "+880",
    country: "Bangladesh",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Dhaka",
    maxLength: 10,
  },
  {
    code: "+1 246",
    country: "Barbados",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Barbados",
    maxLength: 10,
  },
  {
    code: "+375",
    country: "Belarus",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Minsk",
    maxLength: 9,
  },
  {
    code: "+32",
    country: "Belgium",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Brussels",
    maxLength: 9,
  },
  {
    code: "+501",
    country: "Belize",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Belize",
    maxLength: 7,
  },
  {
    code: "+229",
    country: "Benin",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Porto-Novo",
    maxLength: 8,
  },
  {
    code: "+1 441",
    country: "Bermuda",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Bermuda",
    maxLength: 10,
  },
  {
    code: "+975",
    country: "Bhutan",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Thimphu",
    maxLength: 8,
  },
  {
    code: "+591",
    country: "Bolivia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/La_Paz",
    maxLength: 8,
  },
  {
    code: "+387",
    country: "Bosnia and Herzegovina",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Sarajevo",
    maxLength: 9,
  },
  {
    code: "+267",
    country: "Botswana",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Gaborone",
    maxLength: 7,
  },
  {
    code: "+246",
    country: "British Indian Ocean Territory",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Chagos",
    maxLength: 7,
  },
  {
    code: "+673",
    country: "Brunei Darussalam",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Brunei",
    maxLength: 7,
  },
  {
    code: "+359",
    country: "Bulgaria",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Sofia",
    maxLength: 9,
  },
  {
    code: "+226",
    country: "Burkina Faso",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Ouagadougou",
    maxLength: 8,
  },
  {
    code: "+257",
    country: "Burundi",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Bujumbura",
    maxLength: 8,
  },
  {
    code: "+855",
    country: "Cambodia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Phnom_Penh",
    maxLength: 9,
  },
  {
    code: "+237",
    country: "Cameroon",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Douala",
    maxLength: 9,
  },
  {
    code: "+238",
    country: "Cape Verde",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Cape_Verde",
    maxLength: 7,
  },
  {
    code: "+599",
    country: "Caribbean Netherlands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Curacao",
    maxLength: 7,
  },
  {
    code: "+1 345",
    country: "Cayman Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Cayman",
    maxLength: 10,
  },
  {
    code: "+236",
    country: "Central African Republic",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Bangui",
    maxLength: 8,
  },
  {
    code: "+235",
    country: "Chad",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Ndjamena",
    maxLength: 8,
  },
  {
    code: "+56",
    country: "Chile (Punta Arenas)",
    dateFormat: "DD-MM-YYYY",
    timeZone: "America/Punta_Arenas",
    maxLength: 9,
  },
  {
    code: "+86",
    country: "China",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Shanghai",
    maxLength: 11,
  },
  {
    code: "+86",
    country: "China (Urumqi)",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Urumqi",
    maxLength: 11,
  },
  {
    code: "+61",
    country: "Christmas Island",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Christmas",
    maxLength: 9,
  },
  {
    code: "+61",
    country: "Cocos (Keeling) Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Cocos",
    maxLength: 9,
  },
  {
    code: "+57",
    country: "Colombia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Bogota",
    maxLength: 10,
  },
  {
    code: "+269",
    country: "Comoros",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Comoro",
    maxLength: 7,
  },
  {
    code: "+242",
    country: "Congo",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Brazzaville",
    maxLength: 9,
  },
  {
    code: "+682",
    country: "Cook Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Rarotonga",
    maxLength: 5,
  },
  {
    code: "+506",
    country: "Costa Rica",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Costa_Rica",
    maxLength: 8,
  },
  {
    code: "+225",
    country: "Cote d'Ivoire",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Abidjan",
    maxLength: 8,
  },
  {
    code: "+385",
    country: "Croatia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Zagreb",
    maxLength: 9,
  },
  {
    code: "+53",
    country: "Cuba",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Havana",
    maxLength: 8,
  },
  {
    code: "+357",
    country: "Cyprus (Nicosia)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Nicosia",
    maxLength: 8,
  },
  {
    code: "+357",
    country: "Cyprus (Famagusta)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Famagusta",
    maxLength: 8,
  },
  {
    code: "+420",
    country: "Czech Republic",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Prague",
    maxLength: 9,
  },
  {
    code: "+45",
    country: "Denmark",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Copenhagen",
    maxLength: 8,
  },
  {
    code: "+253",
    country: "Djibouti",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Djibouti",
    maxLength: 8,
  },
  {
    code: "+1 767",
    country: "Dominica",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Dominica",
    maxLength: 10,
  },
  {
    code: "+593",
    country: "Ecuador (Guayaquil)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Guayaquil",
    maxLength: 9,
  },
  {
    code: "+593",
    country: "Ecuador (Galapagos)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Galapagos",
    maxLength: 9,
  },
  {
    code: "+20",
    country: "Egypt",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Cairo",
    maxLength: 10,
  },
  {
    code: "+503",
    country: "El Salvador",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/El_Salvador",
    maxLength: 8,
  },
  {
    code: "+240",
    country: "Equatorial Guinea",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Malabo",
    maxLength: 9,
  },
  {
    code: "+291",
    country: "Eritrea",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Asmara",
    maxLength: 7,
  },
  {
    code: "+372",
    country: "Estonia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Tallinn",
    maxLength: 8,
  },
  {
    code: "+251",
    country: "Ethiopia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Addis_Ababa",
    maxLength: 9,
  },
  {
    code: "+500",
    country: "Falkland Islands (Malvinas)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Stanley",
    maxLength: 5,
  },
  {
    code: "+298",
    country: "Faroe Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Faroe",
    maxLength: 6,
  },
  {
    code: "+679",
    country: "Fiji",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Fiji",
    maxLength: 7,
  },
  {
    code: "+358",
    country: "Finland",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Helsinki",
    maxLength: 9,
  },
  {
    code: "+33",
    country: "France",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Paris",
    maxLength: 9,
  },
  {
    code: "+594",
    country: "French Guiana",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Cayenne",
    maxLength: 9,
  },
  {
    code: "+689",
    country: "French Polynesia (Tahiti)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Tahiti",
    maxLength: 6,
  },
  {
    code: "+689",
    country: "French Polynesia (Marquesas)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Marquesas",
    maxLength: 6,
  },
  {
    code: "+689",
    country: "French Polynesia (Gambier)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Gambier",
    maxLength: 6,
  },
  {
    code: "+241",
    country: "Gabon",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Libreville",
    maxLength: 8,
  },
  {
    code: "+220",
    country: "Gambia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Banjul",
    maxLength: 7,
  },
  {
    code: "+995",
    country: "Georgia (Tbilisi)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Tbilisi",
    maxLength: 9,
  },
  {
    code: "+995",
    country: "Georgia (Tskhinvali)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Tskhinvali",
    maxLength: 9,
  },
  {
    code: "+49",
    country: "Germany",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Berlin",
    maxLength: 13,
  },
  {
    code: "+233",
    country: "Ghana",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Accra",
    maxLength: 9,
  },
  {
    code: "+350",
    country: "Gibraltar",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Gibraltar",
    maxLength: 8,
  },
  {
    code: "+30",
    country: "Greece",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Athens",
    maxLength: 10,
  },
  {
    code: "+299",
    country: "Greenland",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Godthab",
    maxLength: 6,
  },
  {
    code: "+1 473",
    country: "Grenada",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Grenada",
    maxLength: 10,
  },
  {
    code: "+590",
    country: "Guadeloupe",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Guadeloupe",
    maxLength: 9,
  },
  {
    code: "+502",
    country: "Guatemala",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Guatemala",
    maxLength: 8,
  },
  {
    code: "+224",
    country: "Guinea",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Conakry",
    maxLength: 9,
  },
  {
    code: "+245",
    country: "Guinea-Bissau",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Bissau",
    maxLength: 7,
  },
  {
    code: "+592",
    country: "Guyana",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Guyana",
    maxLength: 7,
  },
  {
    code: "+509",
    country: "Haiti",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Port-au-Prince",
    maxLength: 8,
  },
  {
    code: "+504",
    country: "Honduras",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Tegucigalpa",
    maxLength: 8,
  },
  {
    code: "+852",
    country: "Hong Kong",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Hong_Kong",
    maxLength: 8,
  },
  {
    code: "+36",
    country: "Hungary",
    dateFormat: "YYYY.MM.DD",
    timeZone: "Europe/Budapest",
    maxLength: 9,
  },
  {
    code: "+354",
    country: "Iceland",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Reykjavik",
    maxLength: 7,
  },
  {
    code: "+91",
    country: "India",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Kolkata",
    maxLength: 10,
  },
  {
    code: "+98",
    country: "Iran, Islamic Republic of",
    dateFormat: "YYYY/MM/DD",
    timeZone: "Asia/Tehran",
    maxLength: 11,
  },
  {
    code: "+964",
    country: "Iraq",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Baghdad",
    maxLength: 10,
  },
  {
    code: "+353",
    country: "Ireland",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Dublin",
    maxLength: 9,
  },
  {
    code: "+972",
    country: "Israel",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Jerusalem",
    maxLength: 9,
  },
  {
    code: "+39",
    country: "Italy",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Rome",
    maxLength: 10,
  },
  {
    code: "+81",
    country: "Japan",
    dateFormat: "YYYY/MM/DD",
    timeZone: "Asia/Tokyo",
    maxLength: 10,
  },
  {
    code: "+962",
    country: "Jordan",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Amman",
    maxLength: 9,
  },
  {
    code: "+254",
    country: "Kenya",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Nairobi",
    maxLength: 9,
  },
  {
    code: "+686",
    country: "Kiribati (Tarawa)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Tarawa",
    maxLength: 5,
  },
  {
    code: "+686",
    country: "Kiribati (Enderbury)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Enderbury",
    maxLength: 5,
  },
  {
    code: "+686",
    country: "Kiribati (Kiritimati)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Kiritimati",
    maxLength: 5,
  },
  {
    code: "+850",
    country: "Korea, Democratic People's Republic of",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Pyongyang",
    maxLength: 10,
  },
  {
    code: "+82",
    country: "Korea, Republic of",
    dateFormat: "YYYY/MM/DD",
    timeZone: "Asia/Seoul",
    maxLength: 10,
  },
  {
    code: "+965",
    country: "Kuwait",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Kuwait",
    maxLength: 8,
  },
  {
    code: "+996",
    country: "Kyrgyzstan",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Bishkek",
    maxLength: 9,
  },
  {
    code: "+856",
    country: "Lao People's Democratic Republic",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Vientiane",
    maxLength: 10,
  },
  {
    code: "+371",
    country: "Latvia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Riga",
    maxLength: 8,
  },
  {
    code: "+961",
    country: "Lebanon",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Beirut",
    maxLength: 8,
  },
  {
    code: "+266",
    country: "Lesotho",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Maseru",
    maxLength: 8,
  },
  {
    code: "+231",
    country: "Liberia",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Africa/Monrovia",
    maxLength: 8,
  },
  {
    code: "+218",
    country: "Libyan Arab Jamahiriya",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Tripoli",
    maxLength: 9,
  },
  {
    code: "+423",
    country: "Liechtenstein",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Vaduz",
    maxLength: 7,
  },
  {
    code: "+370",
    country: "Lithuania",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Europe/Vilnius",
    maxLength: 8,
  },
  {
    code: "+352",
    country: "Luxembourg",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Luxembourg",
    maxLength: 9,
  },
  {
    code: "+853",
    country: "Macao",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Macau",
    maxLength: 8,
  },
  {
    code: "+389",
    country: "Macedonia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Skopje",
    maxLength: 9,
  },
  {
    code: "+261",
    country: "Madagascar",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Antananarivo",
    maxLength: 9,
  },
  {
    code: "+265",
    country: "Malawi",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Blantyre",
    maxLength: 7,
  },
  {
    code: "+60",
    country: "Malaysia (Kuala Lumpur)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Kuala_Lumpur",
    maxLength: 10,
  },
  {
    code: "+60",
    country: "Malaysia (Kuching)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Kuching",
    maxLength: 10,
  },
  {
    code: "+960",
    country: "Maldives",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Maldives",
    maxLength: 7,
  },
  {
    code: "+223",
    country: "Mali",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Bamako",
    maxLength: 8,
  },
  {
    code: "+356",
    country: "Malta",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Malta",
    maxLength: 8,
  },
  {
    code: "+692",
    country: "Marshall Islands",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Majuro",
    maxLength: 7,
  },
  {
    code: "+596",
    country: "Martinique",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Martinique",
    maxLength: 9,
  },
  {
    code: "+222",
    country: "Mauritania",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Nouakchott",
    maxLength: 8,
  },
  {
    code: "+230",
    country: "Mauritius",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Mauritius",
    maxLength: 8,
  },
  {
    code: "+262",
    country: "Mayotte",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Mayotte",
    maxLength: 9,
  },
  {
    code: "+691",
    country: "Micronesia (Pohnpei)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Pohnpei",
    maxLength: 7,
  },
  {
    code: "+691",
    country: "Micronesia (Kosrae)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Kosrae",
    maxLength: 7,
  },
  {
    code: "+691",
    country: "Micronesia (Chuuk)",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Chuuk",
    maxLength: 7,
  },
  {
    code: "+373",
    country: "Moldova",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Chisinau",
    maxLength: 8,
  },
  {
    code: "+377",
    country: "Monaco",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Monaco",
    maxLength: 8,
  },
  {
    code: "+976",
    country: "Mongolia (Ulan Bator)",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Asia/Ulaanbaatar",
    maxLength: 8,
  },
  {
    code: "+382",
    country: "Montenegro",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Podgorica",
    maxLength: 8,
  },
  {
    code: "+1 664",
    country: "Montserrat",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Montserrat",
    maxLength: 10,
  },
  {
    code: "+212",
    country: "Morocco",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Casablanca",
    maxLength: 9,
  },
  {
    code: "+258",
    country: "Mozambique",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Maputo",
    maxLength: 9,
  },
  {
    code: "+95",
    country: "Myanmar",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Yangon",
    maxLength: 10,
  },
  {
    code: "+264",
    country: "Namibia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Windhoek",
    maxLength: 8,
  },
  {
    code: "+674",
    country: "Nauru",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Nauru",
    maxLength: 7,
  },
  {
    code: "+977",
    country: "Nepal",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Kathmandu",
    maxLength: 10,
  },
  {
    code: "+31",
    country: "Netherlands",
    dateFormat: "DD-MM-YYYY",
    timeZone: "Europe/Amsterdam",
    maxLength: 9,
  },
  {
    code: "+687",
    country: "New Caledonia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Noumea",
    maxLength: 8,
  },
  {
    code: "+505",
    country: "Nicaragua",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Managua",
    maxLength: 8,
  },
  {
    code: "+227",
    country: "Niger",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Niamey",
    maxLength: 8,
  },
  {
    code: "+234",
    country: "Nigeria",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Lagos",
    maxLength: 10,
  },
  {
    code: "+683",
    country: "Niue",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Niue",
    maxLength: 4,
  },
  {
    code: "+672",
    country: "Norfolk Island",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Norfolk",
    maxLength: 6,
  },
  {
    code: "+47",
    country: "Norway",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Oslo",
    maxLength: 8,
  },
  {
    code: "+968",
    country: "Oman",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Muscat",
    maxLength: 8,
  },
  {
    code: "+92",
    country: "Pakistan",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Karachi",
    maxLength: 10,
  },
  {
    code: "+680",
    country: "Palau",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Pacific/Palau",
    maxLength: 7,
  },
  {
    code: "+970",
    country: "Palestinian Territory, Occupied (Gaza)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Gaza",
    maxLength: 9,
  },
  {
    code: "+970",
    country: "Palestinian Territory, Occupied (Hebron)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Hebron",
    maxLength: 9,
  },
  {
    code: "+507",
    country: "Panama",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Panama",
    maxLength: 8,
  },
  {
    code: "+675",
    country: "Papua New Guinea (Port Moresby)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Port_Moresby",
    maxLength: 8,
  },
  {
    code: "+675",
    country: "Papua New Guinea (Bougainville)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Bougainville",
    maxLength: 8,
  },
  {
    code: "+595",
    country: "Paraguay",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Asuncion",
    maxLength: 9,
  },
  {
    code: "+51",
    country: "Peru",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Lima",
    maxLength: 9,
  },
  {
    code: "+63",
    country: "Philippines",
    dateFormat: "MM/DD/YYYY",
    timeZone: "Asia/Manila",
    maxLength: 10,
  },
  {
    code: "+872",
    country: "Pitcairn",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Pitcairn",
    maxLength: 5,
  },
  {
    code: "+48",
    country: "Poland",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Warsaw",
    maxLength: 9,
  },
  {
    code: "+351",
    country: "Portugal (Lisbon)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Lisbon",
    maxLength: 9,
  },
  {
    code: "+351",
    country: "Portugal (Madeira)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Madeira",
    maxLength: 9,
  },
  {
    code: "+351",
    country: "Portugal (Azores)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Azores",
    maxLength: 9,
  },
  {
    code: "+974",
    country: "Qatar",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Qatar",
    maxLength: 8,
  },
  {
    code: "+262",
    country: "Réunion",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Reunion",
    maxLength: 9,
  },
  {
    code: "+40",
    country: "Romania",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Bucharest",
    maxLength: 10,
  },
  {
    code: "+250",
    country: "Rwanda",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Kigali",
    maxLength: 9,
  },
  {
    code: "+590",
    country: "Saint Barthélemy",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Barthelemy",
    maxLength: 9,
  },
  {
    code: "+290",
    country: "Saint Helena",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/St_Helena",
    maxLength: 4,
  },
  {
    code: "+1 869",
    country: "Saint Kitts and Nevis",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Kitts",
    maxLength: 10,
  },
  {
    code: "+1 758",
    country: "Saint Lucia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Lucia",
    maxLength: 10,
  },
  {
    code: "+590",
    country: "Saint Martin",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Marigot",
    maxLength: 9,
  },
  {
    code: "+508",
    country: "Saint Pierre and Miquelon",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Miquelon",
    maxLength: 6,
  },
  {
    code: "+1 784",
    country: "Saint Vincent and the Grenadines",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/St_Vincent",
    maxLength: 10,
  },
  {
    code: "+685",
    country: "Samoa",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Apia",
    maxLength: 5,
  },
  {
    code: "+378",
    country: "San Marino",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/San_Marino",
    maxLength: 8,
  },
  {
    code: "+239",
    country: "Sao Tome and Principe",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Sao_Tome",
    maxLength: 7,
  },
  {
    code: "+966",
    country: "Saudi Arabia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Riyadh",
    maxLength: 9,
  },
  {
    code: "+221",
    country: "Senegal",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Dakar",
    maxLength: 9,
  },
  {
    code: "+381",
    country: "Serbia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Belgrade",
    maxLength: 9,
  },
  {
    code: "+248",
    country: "Seychelles",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Mahe",
    maxLength: 7,
  },
  {
    code: "+232",
    country: "Sierra Leone",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Freetown",
    maxLength: 8,
  },
  {
    code: "+65",
    country: "Singapore",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Singapore",
    maxLength: 8,
  },
  {
    code: "+421",
    country: "Slovakia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Bratislava",
    maxLength: 9,
  },
  {
    code: "+386",
    country: "Slovenia",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Ljubljana",
    maxLength: 9,
  },
  {
    code: "+677",
    country: "Solomon Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Guadalcanal",
    maxLength: 5,
  },
  {
    code: "+252",
    country: "Somalia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Mogadishu",
    maxLength: 9,
  },
  {
    code: "+27",
    country: "South Africa",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Johannesburg",
    maxLength: 9,
  },
  {
    code: "+500",
    country: "South Georgia and the South Sandwich Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/South_Georgia",
    maxLength: 5,
  },
  {
    code: "+211",
    country: "South Sudan",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Juba",
    maxLength: 9,
  },
  {
    code: "+34",
    country: "Spain (Madrid)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Madrid",
    maxLength: 9,
  },
  {
    code: "+34",
    country: "Spain (Canary)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Atlantic/Canary",
    maxLength: 9,
  },
  {
    code: "+34",
    country: "Spain (Ceuta)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Ceuta",
    maxLength: 9,
  },
  {
    code: "+94",
    country: "Sri Lanka",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Colombo",
    maxLength: 9,
  },
  {
    code: "+249",
    country: "Sudan",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Khartoum",
    maxLength: 9,
  },
  {
    code: "+597",
    country: "Suriname",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Paramaribo",
    maxLength: 7,
  },
  {
    code: "+268",
    country: "Swaziland",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Mbabane",
    maxLength: 8,
  },
  {
    code: "+46",
    country: "Sweden",
    dateFormat: "YYYY-MM-DD",
    timeZone: "Europe/Stockholm",
    maxLength: 9,
  },
  {
    code: "+41",
    country: "Switzerland",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Zurich",
    maxLength: 9,
  },
  {
    code: "+963",
    country: "Syrian Arab Republic",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Damascus",
    maxLength: 9,
  },
  {
    code: "+886",
    country: "Taiwan",
    dateFormat: "YYYY/MM/DD",
    timeZone: "Asia/Taipei",
    maxLength: 10,
  },
  {
    code: "+992",
    country: "Tajikistan",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Dushanbe",
    maxLength: 9,
  },
  {
    code: "+255",
    country: "Tanzania",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Dar_es_Salaam",
    maxLength: 9,
  },
  {
    code: "+66",
    country: "Thailand",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Bangkok",
    maxLength: 9,
  },
  {
    code: "+670",
    country: "Timor-Leste",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Dili",
    maxLength: 8,
  },
  {
    code: "+228",
    country: "Togo",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Lome",
    maxLength: 8,
  },
  {
    code: "+690",
    country: "Tokelau",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Fakaofo",
    maxLength: 4,
  },
  {
    code: "+676",
    country: "Tonga",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Tongatapu",
    maxLength: 5,
  },
  {
    code: "+216",
    country: "Tunisia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Tunis",
    maxLength: 8,
  },
  {
    code: "+90",
    country: "Turkey",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Istanbul",
    maxLength: 10,
  },
  {
    code: "+993",
    country: "Turkmenistan",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Asia/Ashgabat",
    maxLength: 8,
  },
  {
    code: "+1 649",
    country: "Turks and Caicos Islands",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Grand_Turk",
    maxLength: 10,
  },
  {
    code: "+688",
    country: "Tuvalu",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Funafuti",
    maxLength: 5,
  },
  {
    code: "+256",
    country: "Uganda",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Kampala",
    maxLength: 9,
  },
  {
    code: "+380",
    country: "Ukraine (Kyiv)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Kyiv",
    maxLength: 9,
  },
  {
    code: "+380",
    country: "Ukraine (Uzhgorod)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Uzhgorod",
    maxLength: 9,
  },
  {
    code: "+380",
    country: "Ukraine (Zaporozhye)",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Zaporozhye",
    maxLength: 9,
  },
  {
    code: "+971",
    country: "United Arab Emirates",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Dubai",
    maxLength: 9,
  },
  {
    code: "+44",
    country: "United Kingdom",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/London",
    maxLength: 10,
  },
  {
    code: "+598",
    country: "Uruguay",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Montevideo",
    maxLength: 9,
  },
  {
    code: "+678",
    country: "Vanuatu",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Efate",
    maxLength: 5,
  },
  {
    code: "+379",
    country: "Vatican City State",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Vatican",
    maxLength: 7,
  },
  {
    code: "+58",
    country: "Venezuela",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Caracas",
    maxLength: 10,
  },
  {
    code: "+84",
    country: "Viet Nam",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Ho_Chi_Minh",
    maxLength: 10,
  },
  {
    code: "+681",
    country: "Wallis and Futuna",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Pacific/Wallis",
    maxLength: 5,
  },
  {
    code: "+967",
    country: "Yemen",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Asia/Aden",
    maxLength: 9,
  },
  {
    code: "+260",
    country: "Zambia",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Lusaka",
    maxLength: 9,
  },
  {
    code: "+263",
    country: "Zimbabwe",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Harare",
    maxLength: 9,
  },
  // --- Miscellaneous Territories and Edge Cases ---
  {
    code: "+291",
    country: "Antarctica (Palmer)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Palmer",
    maxLength: 5,
  },
  {
    code: "+672",
    country: "Antarctica (Macquarie)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Macquarie",
    maxLength: 6,
  },
  {
    code: "+672",
    country: "Antarctica (Mawson)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Mawson",
    maxLength: 6,
  },
  {
    code: "+64",
    country: "Antarctica (McMurdo)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/McMurdo",
    maxLength: 10,
  },
  {
    code: "+672",
    country: "Antarctica (Casey)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Casey",
    maxLength: 6,
  },
  {
    code: "+672",
    country: "Antarctica (Vostok)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Vostok",
    maxLength: 6,
  },
  {
    code: "+672",
    country: "Antarctica (Rothera)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Rothera",
    maxLength: 6,
  },
  {
    code: "+672",
    country: "Antarctica (Davis)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Davis",
    maxLength: 6,
  },
  {
    code: "+672",
    country: "Antarctica (Syowa)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Syowa",
    maxLength: 6,
  },
  {
    code: "+291",
    country: "Antarctica (Troll)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Troll",
    maxLength: 5,
  },
  {
    code: "+672",
    country: "Antarctica (DumontDUrville)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/DumontDUrville",
    maxLength: 6,
  },
  {
    code: "+672",
    country: "Antarctica (Base Mawson)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Mawson",
    maxLength: 6,
  },
  {
    code: "+291",
    country: "Antarctica (South Pole)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/South_Pole",
    maxLength: 5,
  },
  {
    code: "+672",
    country: "Australian Antarctic Territory",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Antarctica/Macquarie",
    maxLength: 6,
  },
  {
    code: "+358",
    country: "Åland Islands",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Europe/Mariehamn",
    maxLength: 9,
  },
  {
    code: "+47",
    country: "Svalbard and Jan Mayen",
    dateFormat: "DD.MM.YYYY",
    timeZone: "Arctic/Longyearbyen",
    maxLength: 8,
  },
  {
    code: "+599",
    country: "Curacao",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Curacao",
    maxLength: 7,
  },
  {
    code: "+599",
    country: "Sint Maarten",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Lower_Princes",
    maxLength: 7,
  },
  {
    code: "+599",
    country: "Saba",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Kralendijk",
    maxLength: 7,
  },
  {
    code: "+379",
    country: "Holy See (Vatican City State)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Vatican",
    maxLength: 7,
  },
  {
    code: "+44",
    country: "Guernsey",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Guernsey",
    maxLength: 10,
  },
  {
    code: "+44",
    country: "Isle of Man",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Isle_of_Man",
    maxLength: 10,
  },
  {
    code: "+44",
    country: "Jersey",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/Jersey",
    maxLength: 10,
  },
  {
    code: "+379",
    country: "San Marino",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Europe/San_Marino",
    maxLength: 7,
  },
  {
    code: "+44",
    country: "British Indian Ocean Territory (Diego Garcia)",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Indian/Chagos",
    maxLength: 10,
  },
  {
    code: "+508",
    country: "Saint Pierre and Miquelon",
    dateFormat: "DD/MM/YYYY",
    timeZone: "America/Miquelon",
    maxLength: 6,
  },
  {
    code: "+34",
    country: "Ceuta",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Ceuta",
    maxLength: 9,
  },
  {
    code: "+34",
    country: "Melilla",
    dateFormat: "DD/MM/YYYY",
    timeZone: "Africa/Melilla",
    maxLength: 9,
  },
  // ... and many more minor IANA time zones for accuracy
];
export enum BiwazeEnum {
  CLEAR = "BiWaze® Clear",
  COUGH = "BiWaze® Cough",
}

export enum BiwazeColorEnum {
  CLEAR = "#8CD5FF",
  COUGH = "#FFBF3C",
}
// authConfig.ts
export const AUTH_CONFIG = {
  google: {
    webClientId:
      "683319768053-fl6niojoup557549r9fu778eh5b73243.apps.googleusercontent.com",
    androidWebClientId:
      "683319768053-fl6niojoup557549r9fu778eh5b73243.apps.googleusercontent.com",
    iosClientId:
      "683319768053-3g15rau6vv8uiphnv6ri9d1scicvs7uh.apps.googleusercontent.com",
  },
  facebook: {
    appId: "4345658749054389",
    appSecret: "228b1232f0d5d9b9fa78988985d8a164",
    clientToken: "f19ce0120b007d53159025c329bb0f91",
  },
  apple: {
    clientId: "com.abmrc.arcconnectios",
    webClientId: "com.abmrc.arcconnect.web",
    redirectUrl: "https://arcconnect.abmrc.com/auth/apple",
  },
};

// Unified permission arrays for @capgo/capacitor-health
// Fetch ALL available data types from the plugin
export const READ_PERMISSIONS = [
  "steps",
  "heartRate",
  "restingHeartRate",
  "sleep",
  "oxygenSaturation",
  "respiratoryRate",
  "heartRateVariability",
  "distance",
  "calories",
  "weight",
  "workouts"
];

// Platform-specific permissions (for backwards compatibility)
export const READ_PERMISSIONS_IOS = READ_PERMISSIONS;
export const READ_PERMISSIONS_ANDROID = READ_PERMISSIONS;

export const TRACK_OPTIONS_IOS = [
  { key: "steps", label: "Steps" },
  { key: "heartRate", label: "Heart Rate" },
  { key: "sleep", label: "Sleep" },
];

export const TRACK_OPTIONS_ANDROID = [
  { key: "steps", label: "Steps" },
  { key: "heartRate", label: "Heart Rate" },
  { key: "sleep", label: "Sleep" }, // Now available on Android with @capgo!
];
export const HEALTH_APP_URL_IOS = "x-apple-health://";
export const HEALTH_APP_URL_ANDROID = "google-fit://";
export const TERMS_OF_USE = "terms_of_use";
export const PRIVACY_POLICY = "privacy_policy";
export const ONBOARDING = "onboarding";
export const TERMS_OF_USE_VERSION = "v1.1.0";
export const PRIVACY_POLICY_VERSION = "v1.1.0";
export const IFU_URL = "https://arcconnect.abmrc.com/ifu";
export const USER_MANUAL_PDF_URL = "/decrypt/docs/Arc_Connect_User_Manual_v2.pdf";
export const DISABLE_LOG_MASKING = false; // Set to true locally for debugging. Never commit as true.
